








import Vue from 'vue'
import { oneOf } from '@/utils/helper'

export default Vue.extend({
  props: {
    photo: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      validator: oneOf(['canter', 'top']),
      default: 'canter'
    },
    loading: {
      type: String,
      default: 'auto',
      validator: oneOf(['auto', 'lazy', 'eager'])
    }
  },
  computed: {
    setClass(): string {
      return this.position
    }
  },
  methods: {
    block() {
      return false
    }
  }
})
